module.exports = __webpack_public_path__ + "img/bind.eae6b8c8.png";